require('./mortgageRequestSimpleNoteView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { any } = require('lodash');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCover = require('components/mortgageRequest/mortgageRequestCover/mortgageRequestCover');
const MortgageRequestHeader = require('components/mortgageRequest/mortgageRequestHeader/mortgageRequestHeader');
const { MortgageRequestSimpleNote } = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNote');

// @ constants
const { APORTAR_DOC, AUT_CIRBE, AUT_CIRBE_CO, WAIT_CIRBE_COT, DATOS_VIV, TRAMITAR_NS, WAIT_NS, PROBLEMA_NS } = require('constants/mortgageRequestStates');

// @actions
const mortgageInmueblesActions = require('actions/mortgageRequest/mortgageRequestInmuebles');

class MortgageRequestSimpleNoteView extends React.Component {
    constructor(props) {
        super(props);

        this.isReadOnly = false;
        this.showError = false;
    }

    componentWillMount() {
        const { history, mortgageRequestState, clearEstatesState } = this.props;
        const validStates = [APORTAR_DOC, AUT_CIRBE, AUT_CIRBE_CO, WAIT_CIRBE_COT, DATOS_VIV, TRAMITAR_NS, WAIT_NS, PROBLEMA_NS];
        const mortgageState = mortgageRequestState.get('estado');
        const isValidState = any(validStates, state => state === mortgageState);

        clearEstatesState();

        if (isValidState) {
            this.isReadOnly = mortgageState === TRAMITAR_NS || mortgageState === WAIT_NS;
        } else {
            history.push('/myprofile/mortgage/panel');
        }
    }

    getMappingBreacrumb(isClientWithoutAccounts) {

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestSimpleNote-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        return (
            <div className="mortgage-request-simple-note-view">
                <MortgageRequestCover>
                    <MortgageRequestHeader
                        breadcrumbConfig={this.getMappingBreacrumb(isClientWithoutAccounts)}
                        titleKey="mortgageRequestSimpleNote-title"
                    />
                </MortgageRequestCover>
                <div className="mortgage-request-simple-note-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-offset-2 col-xs-8">
                            <MortgageRequestSimpleNote isClientWithoutAccounts={isClientWithoutAccounts} readOnly={this.isReadOnly} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = MortgageRequestSimpleNoteView;

MortgageRequestSimpleNoteView.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    clearEstatesState: PropTypes.func.isRequired
};

module.exports.MortgageRequestSimpleNoteView = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        immGlobalPosition: state.globalPosition,
    }), {
        clearEstatesState: mortgageInmueblesActions.clearEstatesState
    }
)(withRouter(MortgageRequestSimpleNoteView));
